module.exports = __webpack_public_path__ + "media/video_06.e6f83949.mp4";